import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--persons-empty-fields"
//
// Backs the contact-detail Information tab's "Show empty fields" toggle. The
// Ui::ToggleComponent's checkbox dispatches a bubbling `change`; this controller
// (mounted on the panel wrapper) reveals/hides the empty field rows and, for a
// section whose every field is empty, the whole section (CONEK-6618).
export default class extends Controller {
  static targets = ["empty", "emptySection"]

  toggle(event) {
    const show = event.target.checked
    this.emptyTargets.forEach((el) => el.classList.toggle("hidden", !show))
    this.emptySectionTargets.forEach((el) =>
      el.classList.toggle("hidden", !show),
    )
  }
}
